import * as ambassadorWixLoyaltyReferralV1Program from './loyalty-referral-v1-program-programs.http.js';
import * as ambassadorWixLoyaltyReferralV1ProgramTypes from './loyalty-referral-v1-program-programs.types.js';
import * as ambassadorWixLoyaltyReferralV1ProgramUniversalTypes from './loyalty-referral-v1-program-programs.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getReferralProgram(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GetReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GetReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GetReferralProgramResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GetReferralProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.getReferralProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/program',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetReferralProgram(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.BulkGetReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.BulkGetReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.BulkGetReferralProgramResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.BulkGetReferralProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.bulkGetReferralProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/bulk/programs',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateReferralProgram(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.UpdateReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.UpdateReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.UpdateReferralProgramResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.UpdateReferralProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.updateReferralProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/program',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function activateReferralProgram(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.ActivateReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.ActivateReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.ActivateReferralProgramResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.ActivateReferralProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.activateReferralProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/program/activate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function pauseReferralProgram(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.PauseReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.PauseReferralProgramRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.PauseReferralProgramResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.PauseReferralProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.pauseReferralProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/program/pause',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAiSocialMediaPostsSuggestions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GetAISocialMediaPostsSuggestionsRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GetAISocialMediaPostsSuggestionsRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GetAISocialMediaPostsSuggestionsResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GetAISocialMediaPostsSuggestionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.getAiSocialMediaPostsSuggestions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/program/ai-social-media-posts-suggestions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateAiSocialMediaPostsSuggestions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GenerateAISocialMediaPostsSuggestionsRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GenerateAISocialMediaPostsSuggestionsRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GenerateAISocialMediaPostsSuggestionsResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GenerateAISocialMediaPostsSuggestionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.generateAiSocialMediaPostsSuggestions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/program/ai-social-media-posts-suggestions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getReferralProgramPremiumFeatures(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GetReferralProgramPremiumFeaturesRequest,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GetReferralProgramPremiumFeaturesRequest,
  ambassadorWixLoyaltyReferralV1ProgramUniversalTypes.GetReferralProgramPremiumFeaturesResponse,
  ambassadorWixLoyaltyReferralV1ProgramTypes.GetReferralProgramPremiumFeaturesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1Program.getReferralProgramPremiumFeatures(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/program/premium-features',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ReferralProgram as ReferralProgramOriginal,
  ProgramStatus as ProgramStatusOriginal,
  ProgramStatusWithLiterals as ProgramStatusWithLiteralsOriginal,
  Reward as RewardOriginal,
  RewardOptionsOneOf as RewardOptionsOneOfOriginal,
  RewardType as RewardTypeOriginal,
  RewardTypeWithLiterals as RewardTypeWithLiteralsOriginal,
  Coupon as CouponOriginal,
  CouponDiscountTypeOptionsOneOf as CouponDiscountTypeOptionsOneOfOriginal,
  CouponScopeOrMinSubtotalOneOf as CouponScopeOrMinSubtotalOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  FixedAmountDiscount as FixedAmountDiscountOriginal,
  PercentageDiscount as PercentageDiscountOriginal,
  CouponScope as CouponScopeOriginal,
  Group as GroupOriginal,
  LoyaltyPoints as LoyaltyPointsOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  Emails as EmailsOriginal,
  App as AppOriginal,
  AppWithLiterals as AppWithLiteralsOriginal,
  PremiumFeatures as PremiumFeaturesOriginal,
  GetReferralProgramRequest as GetReferralProgramRequestOriginal,
  GetReferralProgramResponse as GetReferralProgramResponseOriginal,
  BulkGetReferralProgramRequest as BulkGetReferralProgramRequestOriginal,
  BulkGetReferralProgramResponse as BulkGetReferralProgramResponseOriginal,
  ProgramInSite as ProgramInSiteOriginal,
  UpdateReferralProgramRequest as UpdateReferralProgramRequestOriginal,
  UpdateReferralProgramResponse as UpdateReferralProgramResponseOriginal,
  ActivateReferralProgramRequest as ActivateReferralProgramRequestOriginal,
  ActivateReferralProgramResponse as ActivateReferralProgramResponseOriginal,
  PauseReferralProgramRequest as PauseReferralProgramRequestOriginal,
  PauseReferralProgramResponse as PauseReferralProgramResponseOriginal,
  GetAISocialMediaPostsSuggestionsRequest as GetAISocialMediaPostsSuggestionsRequestOriginal,
  GetAISocialMediaPostsSuggestionsResponse as GetAISocialMediaPostsSuggestionsResponseOriginal,
  AISocialMediaPostSuggestion as AISocialMediaPostSuggestionOriginal,
  GenerateAISocialMediaPostsSuggestionsRequest as GenerateAISocialMediaPostsSuggestionsRequestOriginal,
  GenerateAISocialMediaPostsSuggestionsResponse as GenerateAISocialMediaPostsSuggestionsResponseOriginal,
  GetReferralProgramPremiumFeaturesRequest as GetReferralProgramPremiumFeaturesRequestOriginal,
  GetReferralProgramPremiumFeaturesResponse as GetReferralProgramPremiumFeaturesResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  HtmlSitePublished as HtmlSitePublishedOriginal,
  Page as PageOriginal,
  SubscriptionEvent as SubscriptionEventOriginal,
  SubscriptionEventEventOneOf as SubscriptionEventEventOneOfOriginal,
  SubscriptionCreated as SubscriptionCreatedOriginal,
  Subscription as SubscriptionOriginal,
  BillingReference as BillingReferenceOriginal,
  ProviderName as ProviderNameOriginal,
  ProviderNameWithLiterals as ProviderNameWithLiteralsOriginal,
  Cycle as CycleOriginal,
  CycleCycleSelectorOneOf as CycleCycleSelectorOneOfOriginal,
  Interval as IntervalOriginal,
  IntervalUnit as IntervalUnitOriginal,
  IntervalUnitWithLiterals as IntervalUnitWithLiteralsOriginal,
  OneTime as OneTimeOriginal,
  SubscriptionStatus as SubscriptionStatusOriginal,
  SubscriptionStatusWithLiterals as SubscriptionStatusWithLiteralsOriginal,
  ReactivationData as ReactivationDataOriginal,
  ReactivationReasonEnum as ReactivationReasonEnumOriginal,
  ReactivationReasonEnumWithLiterals as ReactivationReasonEnumWithLiteralsOriginal,
  SubscriptionAssigned as SubscriptionAssignedOriginal,
  SubscriptionCancelled as SubscriptionCancelledOriginal,
  CancellationDetails as CancellationDetailsOriginal,
  Initiator as InitiatorOriginal,
  InitiatorWithLiterals as InitiatorWithLiteralsOriginal,
  RefundType as RefundTypeOriginal,
  RefundTypeWithLiterals as RefundTypeWithLiteralsOriginal,
  SubscriptionAutoRenewTurnedOn as SubscriptionAutoRenewTurnedOnOriginal,
  SubscriptionAutoRenewTurnedOff as SubscriptionAutoRenewTurnedOffOriginal,
  SubscriptionUnassigned as SubscriptionUnassignedOriginal,
  UnassignReason as UnassignReasonOriginal,
  UnassignReasonWithLiterals as UnassignReasonWithLiteralsOriginal,
  SubscriptionTransferred as SubscriptionTransferredOriginal,
  RecurringChargeSucceeded as RecurringChargeSucceededOriginal,
  ContractSwitched as ContractSwitchedOriginal,
  ContractSwitchType as ContractSwitchTypeOriginal,
  ContractSwitchTypeWithLiterals as ContractSwitchTypeWithLiteralsOriginal,
  ContractSwitchReason as ContractSwitchReasonOriginal,
  ContractSwitchReasonWithLiterals as ContractSwitchReasonWithLiteralsOriginal,
  ProductPriceIncreaseData as ProductPriceIncreaseDataOriginal,
  PriceIncreaseTrigger as PriceIncreaseTriggerOriginal,
  PriceIncreaseTriggerWithLiterals as PriceIncreaseTriggerWithLiteralsOriginal,
  ProductAdjustment as ProductAdjustmentOriginal,
  ProductAdjustmentWithLiterals as ProductAdjustmentWithLiteralsOriginal,
  SubscriptionNearEndOfPeriod as SubscriptionNearEndOfPeriodOriginal,
  SubscriptionPendingChange as SubscriptionPendingChangeOriginal,
  RecurringChargeAttemptFailed as RecurringChargeAttemptFailedOriginal,
  SubscriptionUpdated as SubscriptionUpdatedOriginal,
  SubscriptionMigratedFromVista as SubscriptionMigratedFromVistaOriginal,
  SubscriptionVistaMigrationReverted as SubscriptionVistaMigrationRevertedOriginal,
  ReferralAppInstallation as ReferralAppInstallationOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-referral-v1-program-programs.types.js';
